export default __webpack_public_path__ + "static/post-deco-right-9d71d9e07b0dc692a9f4e9208eca7e4a.png";